/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import DS from 'ember-data';

interface Args {
  selectedObjectTypeIds: string[];
  onObjectTypeIdsChange: (objectTypeIds: string[]) => unknown;
  triggerId?: string;
  size?: 'md';
}

export default class ObjectTypeFilter extends Component<Args> {
  @service store!: DS.Store;

  get dropdownOptions() {
    let objectTypes = this.store.peekAll('object-type').toArray();
    return objectTypes.map((objectType) => ({
      value: objectType.id,
      label: objectType.name,
    }));
  }

  @action
  onChange(items: Record<string, any>[]) {
    this.args.onObjectTypeIdsChange(items.map((item) => item.value));
  }
}
